import { HomeBorderedTransparentButton } from '@/components/button/button';
import { styled } from '@mui/material';

export const StyledButton = styled(HomeBorderedTransparentButton)`
  width: max-content;
  color: #fff3dccc;
`;
